module.exports = __webpack_public_path__ + "static/media/messenger.b82341b0.svg";